export const Constants = {
  LABEL_KEY: "label",
  VALUE_KEY: "value",
  CHILDREN_KEY: "children"
}
